import { getBackgroundColor, getBorderColor } from '../../colors/colors.alias';
import { getBorderRadius, getBorderWidth, getBorderStyle, } from '../../borders/borders.alias';
import { getBoxShadow } from '../../shadows/shadows.alias';
import { VARIANT_DEFAULT, ELEMENT_MODAL, INTERACTION_STATE_OPEN, } from '../../constants';
export const constants = Object.freeze({
    NAME: 'Modal',
    variants: {
        VARIANT_DEFAULT,
    },
    elements: {
        ELEMENT_MODAL,
    },
    interactionStates: {
        INTERACTION_STATE_OPEN,
    },
});
export default function getModal(transformer, config) {
    const borderStyle = getBorderStyle(transformer, config);
    const borderColor = getBorderColor(transformer, config);
    const borderWidth = getBorderWidth(transformer, config);
    const backgroundColor = getBackgroundColor(transformer, config);
    const borderRadius = getBorderRadius(transformer, config);
    const boxShadow = getBoxShadow(transformer, config);
    return Object.freeze({
        constants,
        elements: {
            [ELEMENT_MODAL]: {
                styles: {
                    backgroundColor: backgroundColor.modal.value,
                    borderColor: borderColor.modal.value,
                    borderRadius: borderRadius.modal.value,
                    borderWidth: borderWidth.modal.value,
                    borderStyle: borderStyle.modal.value,
                    boxShadow: boxShadow.modal.value,
                },
            },
        },
    });
}
